export const HIDE_BALANCE_STORAGE_KEY = 'hide_balance';
